var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-card-header',{style:("background-image:url("+_vm.url+")")},[_c('span',{staticClass:"background-place-image",on:{"click":function (){ return _vm.onHandle(); }}})])}
var staticRenderFns = []

export { render, staticRenderFns }